import React, { useState } from 'react';
import { bool, string } from 'prop-types';
import './Breadcrumbs.scss';
import { NavLink } from 'react-router-dom';
import { useEffect } from 'react';
import bem from '../../utils/bem';
import { useCallback } from 'react';
import { useRef } from 'react';
import DoubleArrow from './SVG/DoubleArrow';

const SECTIONS = [
  {
    name: 'Iniciar',
    url: (tipo, modelo) => `/${tipo}/`,
    show: () => true,
  },
  {
    name: 'Versión',
    url: (tipo, modelo) => `/${tipo}/${modelo}/`,
    show: (tipo, modelo) => tipo && modelo,
  },
  {
    name: 'Color',
    url: (tipo, modelo, version, anio) =>
      `/${tipo}/${modelo}/${version}/${anio}/`,
    show: (tipo, modelo, version, anio) => tipo && modelo && version && anio,
    rel: 'nofollow'
  },
  {
    name: 'Accesorios',
    url: (tipo, modelo, version, anio, color) =>
      `/${tipo}/${modelo}/${version}/${anio}/${color}/accesorios/`,
    show: (tipo, modelo, version, anio, color) =>
      tipo && modelo && version && anio && color,
    rel: 'nofollow'
  },
  {
    name: 'Mantenimiento',
    url: (tipo, modelo, version, anio, color) =>
      `/${tipo}/${modelo}/${version}/${anio}/${color}/mantenimientos/`,
    show: (tipo, modelo, version, anio, color) =>
      tipo && modelo && version && anio && color,
    rel: 'nofollow'
  },
  {
    name: 'Seguro',
    url: (tipo, modelo, version, anio, color) =>
      `/${tipo}/${modelo}/${version}/${anio}/${color}/seguros/`,
    show: (tipo, modelo, version, anio, color) =>
      tipo && modelo && version && anio && color,
    rel: 'nofollow'
  },
  {
    name: 'Financiamiento',
    url: (tipo, modelo, version, anio, color) =>
      `/${tipo}/${modelo}/${version}/${anio}/${color}/financiamiento/`,
    show: (tipo, modelo, version, anio, color) =>
      tipo && modelo && version && anio && color,
    rel: 'nofollow'
  },
  {
    name: 'Resumen',
    url: (tipo, modelo, version, anio, color) =>
      `/${tipo}/${modelo}/${version}/${anio}/${color}/resumen/`,
    show: (tipo, modelo, version, anio, color) =>
      tipo && modelo && version && anio && color,
    rel: 'nofollow'
  },
];

const Breadcrumbs = ({ isVersionPage, tipo, modelo, version, anio, color, colorCode, brandUrl, isSummary }) => {
  const [leftArrow, setLeftArrow] = useState(false);
  const [rightArrow, setRightArrow] = useState(false);

  const makeScroll = useCallback(() => {
    const el = document.querySelector('.breadcrumbs-item .active');
    const inner = document.querySelector('.breadcrumbs-inner')

    if (el) {
      if (el.scrollIntoViewIfNeeded) {
        el.scrollIntoViewIfNeeded(true);
        
      } else {
        el.scrollIntoView(false);
      }
      if (!inner) {
        return;
      }
      const parent = el.parentElement;
      inner.scrollLeft = parent.offsetLeft - ((inner.clientWidth - parent.clientWidth) / 2) - 25;
    }
  }, []);

  const ref = useRef(null);
    
  useEffect(() => {
    makeScroll();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const addScrollFlags = () => {
    const mainNode = ref.current;
    if (!mainNode) return;
    setLeftArrow(mainNode?.scrollLeft !== 0);
    setRightArrow((mainNode?.scrollLeft + mainNode?.clientWidth) !== mainNode?.scrollWidth);
  }

  useEffect(() => {
    if (ref.current === null) {
      return;
    }
    addScrollFlags();
    ref.current.addEventListener('scroll', addScrollFlags);
    return () => {
      if (ref.current === null) {
        return;
      }
      ref.current.removeEventListener('scroll', addScrollFlags);
    };
  }, [ref]);

  useEffect(() => {
    window.addEventListener("orientationchange", makeScroll);
    return () => {
      window.removeEventListener("orientationchange", makeScroll);
    };
  }, [makeScroll]);

  return (
    <div className={bem('breadcrumbs-outer', {
      'is-summary': isSummary
    })}>
      {isSummary && brandUrl && (
        <img src={brandUrl} className="breadcrumbs-logo" alt="Logo" />
      )}
      <div className={bem('breadcrumbs', {
        'left-arrow': leftArrow,
        'right-arrow': rightArrow
      })}>
        <div className={`mobile-inline-flex breadcrumbs-leftarrow ${leftArrow ? 'breadcrumbs-arrow--show':''}`}>
          <DoubleArrow />
        </div>
        <div className={`mobile-inline-flex breadcrumbs-rightarrow ${rightArrow ? 'breadcrumbs-arrow--show':''}`}>
          <DoubleArrow />
        </div>
        <div className="breadcrumbs-inner" ref={r => ref.current = r}>
          {SECTIONS.map((section, index) => {
            const props = {
              exact: true,
              to: section.url(tipo, modelo, version, anio, color)
            };
            if (section.rel) {
              props.rel = section.rel;
            }
            return (
              <div className="breadcrumbs-item" key={section.name}>
                {section.show(tipo, modelo, version, anio, color) ? (
                  <>
                    <NavLink
                      {...props}
                    >
                      {section.name}
                    </NavLink>
                    <span className="breadcrumbs-item__placeholder"/>
                  </>
                ) : (
                  <span>{section.name}</span>
                )}
                {/* {index + 1 !== SECTIONS.length && <Arrow />} */}
              </div>
            );
          })}
        </div>
        
      </div>
    </div>

    
  );
};

Breadcrumbs.propTypes = {
  isVersionPage: bool,
  tipo: string,
  modelo: string,
  version: string,
  anio: string,
  color: string,
};

export default Breadcrumbs;
